import { cn } from '../../lib/utils';

export function ViewEditToggle({
  editing,
  onChange,
  disabled,
  title,
}: {
  editing: boolean;
  onChange: (editing: boolean) => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={editing}
      aria-label="Edit"
      disabled={disabled}
      title={title}
      onClick={() => onChange(!editing)}
      data-testid="view-edit-toggle"
      className={cn(
        'inline-flex items-center gap-2 rounded-md px-2 py-1 text-caption text-muted-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-60',
      )}
    >
      <span>Edit</span>
      <span
        aria-hidden="true"
        className={cn(
          'relative inline-flex h-4 w-7 shrink-0 items-center rounded-full transition-colors',
          editing ? 'bg-primary' : 'bg-muted-foreground/30',
        )}
      >
        <span
          className={cn(
            'inline-block h-3 w-3 rounded-full bg-background shadow-sm transition-transform',
            editing ? 'translate-x-3.5' : 'translate-x-0.5',
          )}
        />
      </span>
    </button>
  );
}
